<div class="edit_btn" *ngIf="this.profile_completenes">
<button color="primary" type="submit" (click)="open_tab()" class="in_search_btn">Edit Search</button>
</div>

<div class="empty" *ngIf="!this.profile_completenes">You must create your profile before you can use this features</div>
<a (click)="navigate()" class="click" *ngIf="!this.profile_completenes">Click here</a>


<div class="fields">
    <ul class="friends-section main-member-list-wrap no-list" #scrollContainer>
        <li *ngFor="let fri of friends" class="member-detail-wrap">
        <app-friends-card [friend]="fri"></app-friends-card>
        </li>
        <li class="shine member-detail-wrap" *ngIf="is_load"></li>
        <li class="shine member-detail-wrap" *ngIf="is_load"></li>
        <li class="shine member-detail-wrap" *ngIf="is_load"></li>
    </ul> 

    <div *ngIf="no_friends"> 
        <p class="empty">No Users Found</p>
        </div>

</div>